import { Button } from "@/shared/ui/Button";
import { useClaimPeriodReward, usePendingPeriods } from "@/shared/hooks";

/**
 * Этап 3: баннер награды за закрытый период + карточка оффера «Перезапуск».
 *
 * Показывается на экране клуба (`TodayPage`), если у юзера есть закрытый
 * период этого клуба с невзятой наградой (`master`/`hunter`) или активный
 * оффер (`unmotivated`).
 *
 * Тексты приходят с сервера готовыми (план §10.4: шаблон — на сервере,
 * клиент ничего не склеивает сам).
 */
interface PeriodRewardBannerProps {
  habitId: string;
}

export function PeriodRewardBanner({ habitId }: PeriodRewardBannerProps) {
  const { data } = usePendingPeriods(habitId);
  const claim = useClaimPeriodReward();

  const period = data?.items.find((item) => item.habit_id === habitId);
  if (!period) return null;

  const isOffer = period.outcome === "unmotivated";

  return (
    <section
      className={`mb-3 rounded-card border p-3 text-sm ${
        isOffer
          ? "border-white/10 bg-surface"
          : "border-primary/30 bg-primary/10"
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="font-semibold text-text">{period.reward_title}</p>
          <p className="text-xs text-muted">{period.reward_subtitle}</p>
        </div>
        {!isOffer && (
          <Button
            variant="primary"
            loading={claim.isPending}
            onClick={() => claim.mutate(period.period_id)}
          >
            {period.claim_button}
          </Button>
        )}
      </div>
    </section>
  );
}
